/**
 * Run a planning mutation API call.
 *
 * @param {Object} params
 * @param {() => Promise<any>} params.apiCall
 * @param {Object} [params.metadata]
 * @param {(result: any) => void|Promise<void>} [params.onSuccess]
 */
export async function runPlanningOperation({
  apiCall,
  metadata: _metadata,
  onSuccess,
}) {
  if (typeof apiCall !== "function") {
    throw new Error("runPlanningOperation requires an apiCall function");
  }
  const result = await apiCall();
  if (typeof onSuccess === "function") {
    await onSuccess(result);
  }
  return result;
}

